import React from "react";

// Data for the roadmap steps
const roadmapData = [
  {
    number: "01",
    title: "Consultation & Evaluation",
    description:
      "Our experts conduct a thorough evaluation of your property, providing actionable insights to enhance its appeal and market potential.",
  },
  {
    number: "02",
    title: "Professional Staging & Marketing",
    description:
      "We execute targeted marketing campaigns, complete with professional photography and listings, to ensure your property captures the attention of high-value guests.",
  },
  {
    number: "03",
    title: "Flawless Management & Guest Care",
    description:
      "We manage all bookings, guest communication, check-ins, and provide 7/24 concierge services, ensuring an unrivaled hospitality experience.",
  },
  {
    number: "04",
    title: "Transparent Reporting & Payouts",
    description:
      "Receive prompt, clear financial statements and regular updates on your property's performance. We operate with absolute transparency and honesty.",
  },
];

// Individual Roadmap Item Component
const RoadmapItem = ({ number, title, description, isLeft }) => {
  // Base classes for the item container
  const itemContainerClasses = `relative w-full md:w-1/2 mb-12 md:mb-0 flex items-center`;

  // Classes to align items left or right on medium screens and up
  // If isLeft is true, it's a left-side item. Otherwise, it's a right-side item.
  const alignmentClasses = isLeft
    ? "md:pr-8 md:text-right md:justify-end"
    : "md:pl-8 md:left-1/2";

  return (
    <div className={`${itemContainerClasses} ${alignmentClasses}`}>
      {/* Background Number */}
      <div
        className={`absolute inset-0 flex items-center ${
          isLeft ? "justify-start" : "justify-end"
        } opacity-10 pointer-events-none`}
      >
        <span
          className="text-[200px] md:text-[280px] font-black text-[#e2e2e1]"
          style={{ lineHeight: "1" }}
          data-aos="fade-up"
        >
          {number}
        </span>
      </div>

      {/* Content */}
      <div
        className="relative z-10 p-6 rounded-lg max-w-[18rem]"
        data-aos-offset="200"
      >
        <h3 className="text-2xl font-medium text-white mb-3">{title}</h3>
        <p className="text-gray-300 leading-relaxed">{description}</p>
      </div>

      {/* Timeline Dot */}
      <div
        className="hidden md:block absolute top-[20%] -translate-y-1/2 bg-[#e2e2e1] w-5 h-5 rounded-full border-4 border-[#e2e2e1]"
        style={isLeft ? { right: "-10px" } : { left: "-10px" }}
        data-aos="zoom-out"
        data-aos-offset="300"
        data-aos-duration="1000"
      ></div>
    </div>
  );
};

export default function RoadMap() {
  return (
    <div className="font-sans flex items-center">
      <div className="container mx-auto w-full h-full">
        <div className="relative wrap h-full">
          <div
            className="hidden md:block border-2-2 absolute border-opacity-20 border-[#e2e2e1] h-full border"
            style={{ left: "50%" }}
          ></div>

          {roadmapData.map((item, index) => (
            <RoadmapItem
              key={item.number}
              number={item.number}
              title={item.title}
              description={item.description}
              isLeft={index % 2 === 0}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
